import { render, staticRenderFns } from "./DropShadowBIcon.vue?vue&type=template&id=57064f88&"
import script from "./DropShadowBIcon.vue?vue&type=script&lang=js&"
export * from "./DropShadowBIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports